import styles from "./FormSection.module.css";
import PropTypes, { node } from "prop-types";
import Button from "../InputControls/Button";
import { createSectionTableLayout } from "../Utils/sectionControlUtil";

import { getLocalStorageItem } from "@maxis/client-logic/utils/localStorageUtil";
import { LOCAL_STORAGE_KEYS } from "@maxis/client-logic/constants/enumerates";
import { existChk } from "@maxis/client-logic/utils/controlsUtil";
import styles1 from "../Utils/sectionControlUtil.module.css";

export const createBtnArea = ({
  btnNodes,
  btnExcel,
  btnInit,
  btnAdd,
  btnSave,
  btnDel,
  additionalBtns,
  checkAuth,
  className,
}) => {
  const btnsJsx = [];
  const findBtnStyle = JSON.parse(
    getLocalStorageItem(LOCAL_STORAGE_KEYS.BUTTON_STYLE)
  );

  if (btnNodes && btnNodes.length > 0) {
    btnsJsx.push(...btnNodes);
  }

  if (btnInit && existChk(btnInit)) {
    btnsJsx.push(
      <Button
        {...(btnInit.ref && { ref: btnInit.ref })}
        key={"btnInit"}
        label={btnInit.label ?? "초기화"}
        onClick={btnInit.onClick}
        colorType={btnInit.colorType ?? findBtnStyle?.btnInit?.colorType}
        iconType={btnInit.iconType ?? findBtnStyle?.btnInit?.iconType}
        authBtn={btnInit.authBtn ?? "INIT"}
        checkAuth={!checkAuth ? btnInit.checkAuth : checkAuth}
        disabled={btnInit.disabled}
      />
    );
  }

  if (btnExcel && existChk(btnExcel)) {
    btnsJsx.push(
      <Button
        {...(btnExcel.ref && { ref: btnExcel.ref })}
        key={"btnExcel"}
        label={btnExcel.label ?? "엑셀"}
        onClick={() => {
          btnExcel.onClick(btnExcel.name ?? null);
        }}
        colorType={
          btnExcel.colorType ?? findBtnStyle?.btnExcel?.colorType ?? "sub1"
        }
        iconType={
          btnExcel.iconType ?? findBtnStyle?.btnExcel?.iconType ?? "btn_down"
        }
        authBtn={btnExcel.authBtn ?? "EXCEL"}
        checkAuth={!checkAuth ? btnExcel.checkAuth : checkAuth}
      />
    );
  }

  if (btnAdd && existChk(btnAdd)) {
    btnsJsx.push(
      <Button
        {...(btnAdd.ref && { ref: btnAdd.ref })}
        key={"btnAdd"}
        label={btnAdd.label ?? "추가"}
        onClick={btnAdd.onClick}
        colorType={
          btnAdd.colorType ?? findBtnStyle?.btnAdd?.colorType ?? "sub3"
        }
        iconType={btnAdd.iconType ?? findBtnStyle?.btnAdd?.iconType}
        authBtn={btnAdd.authBtn ?? "ADD"}
        checkAuth={!checkAuth ? btnAdd.checkAuth : checkAuth}
        disabled={btnAdd.disabled}
      />
    );
  }

  if (btnDel && existChk(btnDel)) {
    btnsJsx.push(
      <Button
        {...(btnDel.ref && { ref: btnDel.ref })}
        key={"btnDel"}
        label={btnDel.label ?? "삭제"}
        onClick={btnDel.onClick}
        colorType={
          btnDel.colorType ?? findBtnStyle?.btnDel?.colorType ?? "sub1"
        }
        iconType={btnDel.iconType ?? findBtnStyle?.btnDel?.iconType}
        authBtn={btnDel.authBtn ?? "DELETE"}
        checkAuth={!checkAuth ? btnDel.checkAuth : checkAuth}
        disabled={btnDel.disabled}
      />
    );
  }
  

  if (btnSave && existChk(btnSave)) {
    btnsJsx.push(
      <Button
        {...(btnSave.ref && { ref: btnSave.ref })}
        key={"btnSave"}
        label={btnSave.label ?? "저장"}
        onClick={btnSave.onClick}
        colorType={
          btnSave.colorType ?? findBtnStyle?.btnSave?.colorType ?? "main"
        }
        iconType={btnSave.iconType ?? findBtnStyle?.btnSave?.iconType}
        authBtn={btnSave.authBtn ?? "SAVE"}
        checkAuth={!checkAuth ? btnSave.checkAuth : checkAuth}
        disabled={btnSave.disabled}
      />
    );
  }

  

  if (additionalBtns) btnsJsx.push(...additionalBtns);

  return (
    <div className={[styles.topBtnWrap, className].join(" ")}>{btnsJsx}</div>
  );
};

function FormSection(props) {
  const {
    children,
    formControls,
    numOfCols,
    formOptions,
    btnNodes,
    btnExcel,
    btnInit,
    btnAdd,
    btnSave,
    btnDel,
    additionalBtns,
    checkAuth,
    btnArea,
    clearTopBorder,
  } = props;

  if (children) {
    const additionalBtnsArry = createBtnArea({
      btnNodes,
      btnExcel,
      btnInit,
      btnAdd,
      btnSave,
      btnDel,
      additionalBtns,
      checkAuth,
    });
    return (
      <>
        {btnArea == "up" && !clearTopBorder && additionalBtnsArry}
        <div
          className={[
            styles.formSection,
            clearTopBorder ? styles.clearTopBorder : "",
          ].join(" ")}
        >
          {children}
        </div>
        {btnArea == "down" && !clearTopBorder && additionalBtnsArry}
      </>
    );
  }

  // --- 수정된 부분: options 객체에 type: "form"을 추가하여 전달합니다. ---
  const mergedFormOptions = {
    ...formOptions,
    type: "form",
  };

  const rowsJsx = createSectionTableLayout(
    formControls,
    numOfCols,
    mergedFormOptions
  );
  // ------------------------------------------------------------------

  const trsJsx = rowsJsx?.map((tds, index) => (
    <div className={styles1.form_row} key={index}>
      {tds}
    </div>
  ));

  const additionalBtnsArry = createBtnArea({
    btnNodes,
    btnExcel,
    btnInit,
    btnAdd,
    btnSave,
    btnDel,
    additionalBtns,
    checkAuth,
  });

  return (
    <>
      {btnArea == "up" && !clearTopBorder && additionalBtnsArry}
      <div
        className={[
          styles.formSection,
          clearTopBorder ? styles.clearTopBorder : "",
        ].join(" ")}
      >
        <div className="form_tbl">
          {trsJsx}
        </div>
      </div>
      {btnArea == "down" && !clearTopBorder && additionalBtnsArry}
    </>
  );
}

FormSection.defaultProps = {
  numOfCols: 4,
  checkAuth: false,
  btnArea: "up",
  clearTopBorder: false,
};

FormSection.propTypes = {
  children: PropTypes.node,
  formControls: PropTypes.object,
  numOfCols: PropTypes.number,
  formOptions: PropTypes.object,
  btnNodes: PropTypes.arrayOf(node),
  btnExcel: PropTypes.object,
  btnInit: PropTypes.object,
  btnAdd: PropTypes.object,
  btnSave: PropTypes.object,
  btnDel: PropTypes.object,
  additionalBtns: PropTypes.arrayOf(node),
  checkAuth: PropTypes.bool,
  btnArea: PropTypes.string,
  clearTopBorder: PropTypes.bool,
};

export default FormSection;